import { render, staticRenderFns } from "./ToastsVariants.vue?vue&type=template&id=06ab3c98&"
import script from "./ToastsVariants.vue?vue&type=script&lang=js&"
export * from "./ToastsVariants.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports